const translations = {
  'studentVisas.seo.title':
    'Cursos TEFL en Barcelona y Sevilla con asistencia para visa de estudiante',
  'studentVisas.seo.description':
    'Cursos elegibles para visa de estudiante en España a largo plazo, renovación y extensión de visa. Visa y permisos de trabajo en España.',

  'studentVisas.sec1.title': 'Programas de Visa de Estudiante',
  'studentVisas.sec1.description':
    'Nuestros programas de visa de estudiante te permiten vivir y trabajar en España mientras estudias.',
  'studentVisas.sec2.title': 'Vivir y trabajar en Barcelona nunca había sido tan fáci',
  'studentVisas.sec2.description': `Si tienes ciudadanía europea, puedes trabajar en España sin visado.

    Si no tienes ciudadanía europea, necesitarás un visado para trabajar y vivir en España. 
    Con un visado de turista, puedes completar nuestro curso Trinity CertTESOL de 4 semanas, 
    si planeas quedarte en Barcelona por más de tres meses, deberás tramitar una visa de estudiante. La buena noticia es que ¡podemos ayudarte!
    `,

  'studentVisas.sec3.op1.title': 'Si quieres formarte como profesor/profesora de inglés',
  'studentVisas.sec3.op1.description': 'Tienes dos opciones para obtener una visa de estudiante',
  'studentVisas.sec3.op2.title': 'Si ya eres profesor/a de inglés',
  'studentVisas.sec3.op2.description': 'Tienes dos opciones para obtener una visa de estudiante',
  'studentVisas.sec3.findOutMore': 'Obtén más información sobre nuestro Curso Docente Avanzado',
  'studentVisas.sec3.notice':
    'Consulta nuestra página de <a> fechas y tarifas </a> para obtener más información.',

  'studentVisas.sec4.title': 'Cursos a largo plazo explicados',
  'studentVisas.sec4.description':
    'Para calificar para una visa de estudiante a largo plazo, debes inscribirte en un curso de al menos 20 horas por semana y de 7 a 12 meses de duración. En TEFL Iberia hemos desarrollado dos cursos para cumplir con este requisito:',
  'studentVisas.sec4.b1.title': 'El Curso Docente Avanzado',
  'studentVisas.sec4.b1.text1':
    'Este es un curso avanzado de TEFL dirigido a aquellas personas que ya tienen alguna capacitación/experiencia laboral en TEFL y desean profundizar su conocimiento de la materia y refrescar sus habilidades.',
  'studentVisas.sec4.b1.text2':
    'Implica una combinación de talleres en persona, observaciones de maestros senior, seminarios web, tareas de reflexión y estudio independiente.',
  'studentVisas.sec4.b1.text3':
    'También obtendrás acceso a nuestra comunidad activa de profesores de Barcelona para compartir consejos, oportunidades laborales, orientación sobre la burocracia española, oportunidades para compartir piso y más.',
  'studentVisas.sec4.b1.price': '<b>150€</b>  por mes o <b2>1500€</b2> por 1 año',
  'studentVisas.sec4.b2.title': 'Catalán y Curso Docente Avanzado',
  'studentVisas.sec4.b2.text1':
    'Este curso tiene todos los beneficios del Curso Docente Avanzado, más 10 horas por semana de clases de Catalán acreditadas por el Ajuntament de Barcelona. ',
  'studentVisas.sec4.b2.text2':
    'Estudiar catalán durante 10 horas a la semana te llevará de principiante total a fluidez en menos de 12 meses. También existe la opción de hacer un solo mes de inmersión al catalán y luego continuar con algún otro idioma que te apasione. ¡Adquiere otra habilidad y sácale el máximo partido a tu experiencia en España con esta opción!',
  'studentVisas.sec4.b2.price': '<b>275€</b> por mes o <b2>3000€</b2> por 1 año',

  'studentVisas.sec5.title': '¿Qué hace que nuestro servicio de visa sea diferente?',
  'studentVisas.sec5.b1.title': 'Antes de partir:',
  'studentVisas.sec5.b1.ben1':
    'Orientación detallada sobre cómo reunir toda la documentación necesaria.',
  'studentVisas.sec5.b1.ben2': 'Ayuda para completar el formulario de solicitud.',
  'studentVisas.sec5.b1.ben3':
    'Descuento especial en seguro médico para estudiantes de TEFL Iberia.',
  'studentVisas.sec5.b1.ben4': 'Entrega rápida de tu carta de aceptación al curso.',
  'studentVisas.sec5.b1.ben5': 'Tasa de éxito del 96% en el procesamiento de visas de estudiantes.',
  'studentVisas.sec5.b1.ben6':
    '96% success rate in processing student visas and minimal rejections.',

  'studentVisas.sec5.b2.title': 'Una vez que estés en Barcelona:',
  'studentVisas.sec5.b2.ben1':
    'Reservaremos tu cita TIE por ti (lee más sobre el TIE <a>aquí</a>). Agilizaremos el proceso. ¡Te ahorraremos tiempo y molestias!    ',
  'studentVisas.sec5.b2.ben2':
    'Un contacto de la escuela te acompañará personalmente a la oficina de extranjería para ayudarte con el papeleo.',
  'studentVisas.sec5.b2.ben3':
    'La escuela te brindará orientación continua sobre cómo y dónde obtener todos los documentos necesarios para obtener tu tarjeta de estudiante (TIE - Tarjeta de identidad de extranjero).',
  'studentVisas.sec5.b2.text':
    'El servicio de la  reserva de la tarjeta de estudiante (TIE), el registro de la vivienda (empadronamiento) y el acompañamiento a las citas tienen un coste adicional de 160€.',

  'studentVisas.sec6.title': '¿Qué Documentos Necesito?',
  'studentVisas.sec6.benText': 'El consulado español requiere los siguientes documentos:',
  'studentVisas.sec6.ben1': 'Pasaporte, válido por 6 meses más allá de tu estancia en España.',
  'studentVisas.sec6.ben2':
    'Formulario de solicitud de visado de estudiante español (<a>pdf descargable</a>)',
  'studentVisas.sec6.ben3': '2 fotos de pasaporte.',
  'studentVisas.sec6.ben4':
    'Carta de inscripción de la escuela (te la enviamos una vez que seas aceptado en el curso).',
  'studentVisas.sec6.ben5': 'Verificación de antecedentes penales con la Apostilla de La Haya. ',
  'studentVisas.sec6.ben6': 'Comprobante de pago de la totalidad del curso.',
  'studentVisas.sec6.ben7': 'Certificado médico.',
  'studentVisas.sec6.ben8': 'Seguro médico.',
  'studentVisas.sec6.ben9': 'Prueba de fondos suficientes para mantenerte durante tu estadía.',
  'studentVisas.sec6.ben10': 'Comprobante de domicilio en tu país de origen.',

  'studentVisas.sec7.title': '¿Tienes preguntas?  <accent>Pregúntanos cualquier cosa.</accent>',
  'studentVisas.sec7.text1':
    ' Si deseas analizar el proceso con más detalle, puedes ponerte en contacto con  <a>coordination@tefl-iberia.com</a> con preguntas o reservar  <a2>una cita para hablar</a2> en la escuela / videollamada.    ',
  'studentVisas.sec7.text2':
    'Si deseas leer sobre experiencias recientes de primera mano, te recomendamos que te suscribas a la página de la <a>Asociación de profesores de TEFL de Barcelona</a> o a la página de <a2>Profesores de TEFL en Sevilla</a2> en Facebook. Son comunidades en línea muy activas con toneladas de profesores de fuera de la UE y aprendices de TEFL que comparten sus experiencias.  Si usas su función de búsqueda en la esquina superior derecha de la página para buscar, por ejemplo, "visado de estudiante", encontrarás muchas discusiones activas.    ',
};

export default translations;
